/** Eenmalige Inbox-tab intro (inboxIntro), alleen desktop. */
import { useCallback, useEffect, useRef, useState } from 'react';
import { ONBOARDING_HINT_INBOX_INTRO } from '@/constants/onboardingHints';
import { useTier } from '@/features/tier/useTier';
import {
  isDesktopBreakpoint,
  useBreakpoint,
} from '@/hooks/ui/useBreakpoint';
import { markHintSeen } from '@/services/userService';

/**
 * @param {Object} params
 * @param {string | undefined} params.userId
 */
export function useInboxIntroHint({ userId }) {
  const breakpoint = useBreakpoint();
  const isDesktop = isDesktopBreakpoint(breakpoint);
  const { seenHints, profileLoaded } = useTier();
  const initRef = useRef(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (initRef.current) {
      return;
    }
    if (!userId || !profileLoaded || !isDesktop) {
      return;
    }
    initRef.current = true;
    if (seenHints.includes(ONBOARDING_HINT_INBOX_INTRO)) {
      return;
    }
    setOpen(true);
    void markHintSeen(userId, ONBOARDING_HINT_INBOX_INTRO);
  }, [userId, profileLoaded, seenHints, isDesktop]);

  const dismiss = useCallback(() => {
    setOpen(false);
  }, []);

  return { showHint: open, dismissHint: dismiss };
}
